import { Spinner } from "@chakra-ui/react"
import { GetGranularityConfiguration, Granularity } from "@hydrologiq/common/types/reporting/Granularity"
import { useQuery } from "@apollo/client"
import * as gqlTypes from "@hydrologiq/gql/graphql"
import { IANATimeZone, toTimestamp } from "@hydrologiq/common/helpers/date"
import { DateTime } from "timezonecomplete"
import Download from "@hydrologiq/shared/reporting/Download"
import { usageCsv } from "@hydrologiq/shared/reporting/usageCsv"
interface CustomerUsageDownloadProps {
  start: DateTime
  end: DateTime
  granularity: Granularity
  customer: string
  customerName: string
  callback?: () => void
}

function CustomerUsageDownload({
  start,
  end,
  customer,
  granularity,
  customerName,
  callback,
}: CustomerUsageDownloadProps) {
  const granularityConfig = GetGranularityConfiguration(granularity)

  const { loading, error, data } = useQuery(gqlTypes.GetCustomerUsageDocument, {
    variables: {
      id: customer,
      start: toTimestamp(start, true),
      end: toTimestamp(end, true),
      freq: granularityConfig.queryFrequency,
      tz: IANATimeZone(),
    },
  })

  if (loading) return <Spinner />
  if (error || !data) return "An error has occurred: " + error?.message

  return (
    <Download
      start={start}
      end={end}
      granularity={granularity}
      baseName={customerName}
      callback={callback}
      data={usageCsv(data.customerUsage || [])}
    />
  )
}

export default CustomerUsageDownload
